var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "div",
        [
          _c("LoadingSpinner", {
            attrs: { message: _vm.$t("lang.views.families.data_loading") },
          }),
        ],
        1
      )
    : _c(
        "div",
        [
          _c("Search", {
            attrs: {
              title: "Etiquetas",
              btnLabel: "Nueva etiqueta",
              defaultValue: "",
              goTo: "/createTag",
            },
            on: { searchEvent: _vm.searchTags },
          }),
          _c("TagsCardList", { attrs: { tags: _vm.tagsCollection } }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }